/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo } from "react";
import useStyles from "./styles";
import ImagesConfig from "components/ImagesConfig";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";

const ProductItemLoading = props => {
	const classes = useStyles();

	return (
		<Grid
			style={{ position: "relative" }}
			classes={{ root: classes.rootProduct }}
		>
			<Grid container>
				<Grid item xs={4} classes={{ root: classes.images }}>
					<ImagesConfig
						image={""}
						imageDefault={Images.icProductDefault}
						width={80}
						height={80}
					/>
				</Grid>
				<Grid item xs={8} style={{ position: "relative" }}>
					<Grid classes={{ root: classes.infoProduct }}>
						<Grid
							classes={{ root: classes.nameProduct }}
							container
						/>
						<Grid container>
							<Grid item xs={6} classes={{ root: classes.price }}>
								Lẻ{" "}
								<span
									className={classes.nameProduct}
									style={{
										padding: "4px 25px",
										width: "100%"
									}}
								/>{" "}
								<span>Đ</span>
							</Grid>
							<Grid item xs={6} classes={{ root: classes.price }}>
								Thùng{" "}
								<span
									className={classes.nameProduct}
									style={{
										padding: "4px 25px",
										width: "100%"
									}}
								/>{" "}
								<span>Đ</span>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};
export default memo(ProductItemLoading);
